import { render, staticRenderFns } from "./_IbxAssessmentItemCard.vue?vue&type=template&id=0682bda2"
import script from "./_IbxAssessmentItemCard.vue?vue&type=script&lang=ts"
export * from "./_IbxAssessmentItemCard.vue?vue&type=script&lang=ts"
import style0 from "./_IbxAssessmentItemCard.vue?vue&type=style&index=0&id=0682bda2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports